var AccountsService = /** @class */ (function () {
    function AccountsService(api) {
        var _this = this;
        this.hasSecret = function (appId, accountSecretType) {
            var url = "/accounts/secrets/".concat(appId, "/").concat(accountSecretType);
            return _this.API.get(url);
        };
        this.saveSecret = function (appId, _a) {
            var account_secret_type = _a.account_secret_type, _b = _a.meta, meta = _b === void 0 ? {} : _b, secret_key = _a.secret_key;
            var url = "/accounts/secrets/".concat(appId, "/save");
            var body = new FormData();
            body.append('account_secret_type', account_secret_type);
            body.append('secret_key', secret_key);
            body.append('meta', JSON.stringify(meta));
            body.append('name', secret_key === null || secret_key === void 0 ? void 0 : secret_key.name);
            return _this.API.postFormData(url, body);
        };
        this.hasIosAppStoreConfig = function (appId) {
            var url = "/accounts/secrets/ios/".concat(appId);
            return _this.API.get(url);
        };
        this.saveIosAppStoreConfig = function (appId, config, _a) {
            var app = _a.app, notification = _a.notification;
            var url = "/accounts/secrets/ios/".concat(appId, "/save");
            var body = new FormData();
            body.append('ios_license_certificate', config.ios_license_certificate);
            body.append('ios_license_private_key', config.ios_license_private_key);
            body.append('ios_provisioning_profile', config.ios_provisioning_profile);
            body.append('ios_provisioning_profile_notification', config.ios_provisioning_profile_notification);
            body.append('ios_provisioning_profile_meta', JSON.stringify({
                profile_name: app,
            }));
            body.append('ios_provisioning_profile_notification_meta', JSON.stringify({
                profile_name: notification,
            }));
            return _this.API.postFormData(url, body);
        };
        this.checkAndroid = function (appId) {
            var url = "/accounts/setup/".concat(appId, "/android");
            return _this.API.get(url);
        };
        this.setupAndroid = function (appId, bundleId, keyAlias, keyPassword) {
            var url = "/accounts/setup/".concat(appId, "/android");
            return _this.API.postGetFile(url, { bundleId: bundleId, keyAlias: keyAlias, keyPassword: keyPassword });
        };
        this.downloadAndroidPubCert = function (appId) {
            return _this.API.getFile("/accounts/setup/".concat(appId, "/android/cert"));
        };
        this.checkIOS = function (appId) {
            var url = "/accounts/setup/".concat(appId, "/ios");
            return _this.API.get(url);
        };
        this.setupIOS = function (appId, bundleId, teamId) {
            var url = "/accounts/setup/".concat(appId, "/ios");
            return _this.API.post(url, { bundleId: bundleId, teamId: teamId });
        };
        this.getFirebaseProjectId = function (appId) {
            var url = "/accounts/".concat(appId, "/firebase");
            return _this.API.get(url);
        };
        this.getCertificateDetails = function (appId) {
            var url = "/accounts/".concat(appId);
            return _this.API.get(url);
        };
        this.API = api;
    }
    return AccountsService;
}());
export { AccountsService };
